export default __webpack_public_path__ + "6e5a2d0b8a1f7486ebd149c0e49cb08f.png";